import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Receipt } from "@phosphor-icons/react";
import { timeAgo } from "@/pages/Dashboard";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/audit-logs").then(r => setLogs(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500">Compliance</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Audit Log</h1>
        <p className="mt-1.5 text-sm text-slate-500 max-w-2xl">Every OAuth event — code issuance, token exchange, refresh, revoke, application changes — is timestamped here.</p>
      </div>

      {loading ? <div className="text-sm text-slate-500">Loading…</div> : logs.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-12 text-center" data-testid="empty-audit">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#FFF3E0]">
            <Receipt size={24} className="text-[#FF6B00]" />
          </div>
          <h3 className="font-display text-lg font-semibold">No audit events yet</h3>
        </div>
      ) : (
        <div className="rounded-xl border border-[#E2E8F0] bg-white">
          <ol className="relative px-6 py-4" data-testid="audit-list">
            {logs.map((e) => (
              <li key={e.id} className="relative flex gap-4 border-l-2 border-slate-100 pl-5 pb-5 last:pb-0" data-testid={`audit-item-${e.id}`}>
                <span className="absolute -left-[7px] top-1 h-3 w-3 rounded-full bg-white border-2 border-[#FF6B00]" />
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="rounded-full bg-slate-100 px-2 py-0.5 font-mono text-[10px] text-slate-700">{e.event_type}</span>
                    <span className="text-[11px] text-slate-500">{timeAgo(e.created_at)}</span>
                    <span className="text-[11px] text-slate-400">· {new Date(e.created_at).toLocaleString()}</span>
                  </div>
                  <div className="mt-1 text-sm text-[#0F172A]">{e.message}</div>
                  {Object.keys(e.metadata || {}).length > 0 && (
                    <pre className="mt-1.5 rounded-md bg-slate-50 px-3 py-2 text-[11px] font-mono text-slate-700 overflow-auto">{JSON.stringify(e.metadata, null, 2)}</pre>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
